<div class="previous-step" *ngIf="chooseTemplateFlowService.taskProcessContext.engagement">
  <div translate="engagement/send-message/choose-message-template/from"></div>
  &nbsp;
  <app-site-icon-and-name [item]="chooseTemplateFlowService.taskProcessContext.site">
    <strong>{{ chooseTemplateFlowService.taskProcessContext.site['label'] }}</strong> </app-site-icon-and-name
  >&nbsp;
  <div translate="engagement/send-message/choose-message-template/to"></div>
  &nbsp;
  <strong>{{ engagementService.strategy.externalUser }}</strong>

  <ion-button (click)="back()" size="small" fill="clear">
    <span>{{ 'common/change' | translate }}</span>
  </ion-button>
</div>

<div class="choose-template-wrapper">
  <div class="editor-and-send-buttons">
    <h3 translate="m/task-process/choose-message-template/title"></h3>

    <mat-form-field class="search">
      <mat-label translate="task/message-template/select-template/search"></mat-label>
      <ion-icon name="search-outline" matPrefix>search</ion-icon>
      <input autocomplete="off" type="text" [formControl]="searchCtrl" matInput />
      <ion-icon
        role="button"
        name="close-outline"
        *ngIf="searchCtrl?.value"
        (click)="clearSearch()"
        matSuffix></ion-icon>
    </mat-form-field>
    <div class="kakaotalk-templates">
      <ion-radio-group [value]="selected">
        <div class="selectable" *ngFor="let template of templatesFiltered">
          <app-kakaotalk-template-item [template]="template" (click)="selected = template.id">
            <ion-radio mode="md" [value]="template.id"> </ion-radio>
          </app-kakaotalk-template-item>
        </div>
      </ion-radio-group>
    </div>
  </div>
  <ion-button class="next-button" (click)="composeTheMessage()" [disabled]="!selected">
    <span translate="engagement/send-message/choose-message-template/compose-message"></span>
  </ion-button>
</div>
